'use client';

import { useAuth } from '@/hooks/useAuth';
import { useEffect, useState } from 'react';
import { useToast } from '@/hooks/use-toast';
import { getDiasSS, getProgramaSSConfig, getCityMapConfig } from '@/lib/actions';
import { DiaSS, ProgramaSSConfig } from '@/lib/types';
import { ordenarDiasSS } from '@/lib/programa-ss';
import { AVISO_PROGRAMA_SS, ProgramaSSBook } from '@/components/programa-ss/ProgramaSSBook';

/**
 * El libro vive en `@/components/programa-ss/ProgramaSSBook` porque también se
 * monta en la portada pública; aquí solo se cargan los datos y se le pasan.
 */
export default function JartinetProgramaSemanaSantaPage() {
  const { jartinetData, loading: authLoading } = useAuth();
  const [days, setDays] = useState<DiaSS[]>([]);
  const [config, setConfig] = useState<ProgramaSSConfig | null>(null);
  const [cityMapUrl, setCityMapUrl] = useState<string | null>(null);
  const [isLoadingData, setIsLoadingData] = useState(true);
  const [libroAbierto, setLibroAbierto] = useState(false);
  const { toast } = useToast();

  useEffect(() => {
    const fetchPageData = async () => {
      setIsLoadingData(true);
      const [daysResult, configResult, cityMapResult] = await Promise.all([getDiasSS(), getProgramaSSConfig(), getCityMapConfig()]);
      if (daysResult.error) {
        toast({ title: 'Error', description: `No se pudieron cargar los datos del programa: ${daysResult.error}`, variant: 'destructive' });
      } else {
        // Orden litúrgico por nombre: el `orden` de `dias_ss` está duplicado en
        // algunos días y colaba el Domingo de Resurrección antes de la Madrugá.
        setDays(ordenarDiasSS(daysResult.dias || []));
      }
      setConfig(configResult.config);
      setCityMapUrl(cityMapResult.config?.mapImageUrl || null);
      setIsLoadingData(false);
    };
    if (!authLoading) fetchPageData();
  }, [authLoading, toast]);

  return (
    <div className="flex flex-col gap-4">
      {!libroAbierto && (
        <div className="mx-auto max-w-3xl text-center">
          <h1 className="font-headline text-5xl font-bold text-primary">Programa Semana Santa Jartiland 2026</h1>
          <p className="mt-3 text-sm italic text-amber-500/80">{AVISO_PROGRAMA_SS}</p>
        </div>
      )}

      <ProgramaSSBook
        days={days}
        config={config}
        cityMapUrl={cityMapUrl}
        allHermandades={jartinetData.hermandades || []}
        allBandas={jartinetData.bandas || []}
        isLoading={authLoading || isLoadingData}
        onOpenChange={setLibroAbierto}
      />
    </div>
  );
}
